import { render, staticRenderFns } from "./BookingDetail.vue?vue&type=template&id=4b51e8ca&scoped=true"
import script from "./BookingDetail.vue?vue&type=script&lang=js"
export * from "./BookingDetail.vue?vue&type=script&lang=js"
import style0 from "./BookingDetail.vue?vue&type=style&index=0&id=4b51e8ca&prod&lang=less&scoped=true"
import style1 from "./BookingDetail.vue?vue&type=style&index=1&id=4b51e8ca&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b51e8ca",
  null
  
)

export default component.exports